import io from 'socket.io-client'
import { getAccessToken } from '@/auth'
export default class SocketClient {
    constructor(store) {
            this.$store = store;
            this.$socket_connect = null
        }
        // 1 =======================INIT SOCKETIO CLIENT=======================
    initSocket(SOCKET_URL, context) {
        this.$socket_connect = io(SOCKET_URL, {
            // demo query 
            query: {
                token: getAccessToken(),
                debug: 'dev',
            },
        });

        // (custom event) error message from socketio server
        this.$socket_connect.on('error', error => console.warn('[SOCKET] custom error message:', error));
        // (system event) connect timeout
        this.$socket_connect.on('connect_timeout', error => console.warn('[SOCKET] timeout message:', error));

        // (system event) connect false
        this.$socket_connect.once('connect_error', error => {
            context.commit('UPDATE_ONLINE_STATUS', false);

            console.log('[SOCKET] connect error:', error);
        });

        // (system event) reconnect success
        this.$socket_connect.once('reconnect', () => {
            // console.log('reconnect')
            context.commit('UPDATE_ONLINE_STATUS', true);
            // console.log('[SOCKET] reconnect success');
        });

        // (custom event) login success
        this.$socket_connect.once('server-login-ok', id => {
            // console.log('login ok')
            context.commit('UPDATE_ONLINE_STATUS', true);
            // check socket login user and api login user is matching
            // if (id === this.$store.state.current_user.id) {
            //     context.commit('UPDATE_ONLINE_STATUS', true);

            //   // setup chat event
            //   this._setupSocketChattingEvent();

            // } else {
            //   console.warn('[SOCKET] login user not match cms login user!');
            // }
        });
    }

    // 2 =========================SOCKETIO CLIENT FUNCTION==================================
    socket_reconnect() {
        // console.log('[SOCKET] manual reconnect');
        if (typeof this.$socket_connect.reconnect == 'function') this.$socket_connect.reconnect();
    }

    socket_disconnect() {
        // console.log('[SOCKET] manual disconnect');
        if (typeof this.$socket_connect.disconnect == 'function') this.$socket_connect.disconnect();
    }

    sendMessage(message_string, user_target_id) {
        if (user_target_id) {
            this.$socket_connect.emit('client-chat-message', { msg: message_string, r_id: user_target_id });

            // // send message dong thoi goi socket cap nhat lai tat ca message user thanh da doc
            // if (this.$store.state.kara_last_send_message && this.$store.state.kara_last_send_message.u_id == user_target_id) {
            //   console.log('Client-chat-receive-ok');

            //   this.$socket_connect.emit('client-chat-receive-ok', {
            //     time: this.$store.state.kara_last_send_message.time,
            //     u_id: this.$store.state.kara_last_send_message.u_id
            //   })
            // }
        }
    }

    clearUnread() {
        if (this.$store.state.kara_last_send_message) {
            this.$socket_connect.emit('client-chat-receive-ok', {
                time: this.$store.state.kara_last_send_message.time,
                u_id: this.$store.state.kara_last_send_message.u_id
            });
        }
    }

    sendImage(file, user_target_id) {
        if (user_target_id) {
            this.$socket_connect.emit('client-chat-image', { msg: '', r_id: user_target_id, file: file });
        }
    }

    sendGift(giftId, userId) {
        this.$socket_connect.emit('client-chat-gift', { r_id: userId, gift_id: giftId });
    }
    sendLocation(location, user_target_id) {
        if (user_target_id) {
            let result = this.$socket_connect.emit('client-chat-location', { msg: '', r_id: user_target_id, location: location });
        }
    }

    receiveMessage(time, u_id) {
        this.$socket_connect.emit('client-chat-receive-ok', {
            time: time,
            u_id: u_id
        })
    }

    openImage(message) {
        this.$socket_connect.emit('client-chat-open-ok', {
            msg_id: message.msgID,
            r_id: message.rID,
            u_id: message.uID,
            time: message.time,
            showed: 1,
        })
    }

    typingMessage(user_target_id, typing_status = 0) {
        this.$socket_connect.emit('client-chat-message-typing', { typing: typing_status, r_id: user_target_id });
    }

    // 3 ========================= REGISTER SOCKETIO EVENT =========================
    _setupSocketChattingEvent() {
        this.$socket_connect.on('server-message-is-read', message => {
            // console.log('socket user read:::::::', message);
            // this.$store.dispatch('updateMessageIsRead', message);
        });

        this.$socket_connect.on('server-message-is-open', message => {
            // console.log('socket user open:::::::', message);
            // this.$store.dispatch('actionTargetOpenImage', message);
        });

        this.$socket_connect.on('server-chat-receive', message => {
            // console.log('[SOCKET] receive message: ', message);
            // check co dang chat voi user dang gui message khong
            if (message.u_id == this.$store.state.current_user.id) {
                //update lai message list
                // console.log('[SOCKET] receive message: ', message);
                this.$store.commit('UPDATE_NEW_MESSAGE', message);
            }
            // update message unread count
            // this.$store.dispatch('updateMessageUnread', message.u_id);
        });

        this.$socket_connect.on('server-chat-send-ok', message => {
            // clear unread for chattimer
            // if (message.chat_timer) {
            //   this.$socket_connect.emit('Client-chat-receive-ok', {
            //     time: message.time,
            //     u_id: message.u_id
            //   })
            // }
            // console.log('chat ok')

            if (message.r_id == this.$store.state.current_user.id) {
                // update message in room
                // this.$store.commit('UPDATE_SENDING_STATUS', false);
                this.$store.commit('UPDATE_NEW_MESSAGE', message);
                // this.$store.dispatch('clearMessageUnread', message.r_id);
                // console.log('[SOCKET] message send ok: ', message);
            } else {
                // console.log('[SOCKET] message send ok (other user): ', message);
            }
        });

        // message typping
        this.$socket_connect.on('server-chat-message-typing', typing_data => {
            if (typing_data.u_id == this.$store.state.current_user.id) {
                this.$store.commit('UPDATE_TARGET_TYPING', typing_data.typing);
                // console.log('[SOCKET] target user update typing: ', typing_data);
            }
        });
    }

    clientChatCall(params) {
        this.$socket_connect.emit('client-chat-call', params);
    }

    clientCallProcess(params) {
        this.$socket_connect.emit('client-call-process', params);
    }

    setupSocketCallEvent() {
        this.$socket_connect.on('server-call-is-process', message => {
            // console.log('server-call-is-process return data:::::::', message);
            this.$store.dispatch('call/serverCallIsProcess', message);

        });

        this.$socket_connect.on('server-call-is-candidate', message => {
            this.$store.dispatch('call/setCandidate', message);
        });

        this.$socket_connect.on('server-chat-send-ok', message => {
            // console.log('server chat send ok', message);
            // this.$store.dispatch('call/showCalling', message);
        });

        this.$socket_connect.on('server-chat-receive', message => {
            // console.log('server chat receive', message);
            this.$store.dispatch('call/serverChatReceive', message);
            // this.$store.dispatch('call/showCalling', message);
        });
    }

    sendCandidate(params) {
        this.$socket_connect.emit('client-call-candidate', params);
    }

    sendAnswerToRemote(message_string, user_target_id, params) {
        if (user_target_id) {
            const d = new Date();
            this.$socket_connect.emit('client-call-process', {
                time: d.getTime(),
                type: 'sigmaBlur',
                msg_data: {
                    agency_id: 12,
                    msg_id: '1156-1112-1640234698785',
                    msg_uuid: '2ebbbe9b-c873-4c66-9d80-3f8e50a279ca',
                    r_id: 1112,
                    u_id: 1156,
                    msg: '',
                    type: 'call',
                    time: d.getTime(),
                    chat_center: 'video_call',
                    keijiban_id: '',
                    supports_video: '1',
                    param: { caller: [Object], start_time: d.getTime() }
                },
                u_id: 1156,
                sigma_blur: '0.0',
                desc: params,
                desc_type: 'answer',
            });
        }
    }
}